import { LIGHT_GRAY, LOW_BLUE, NEAR_WHITE, GRAY } from "@shape/reef-shared";
import { Link } from "react-router-dom";
import styled from "styled-components";

interface ColumnsProps {
  spacingBetween?: string;
  marginBottom?: number;
  width?: string;
}

export const GridContainer = styled.div<{ height?: string; halfValue?: string }>`
  width: ${({ halfValue }) => halfValue || "100%"};
  height: ${({ height }) => height || "calc(100vh - 300px)"};
  flex-direction: column;
  justify-content: flex-start;
  max-height: 100%;

  .grid-container {
    .grid-body-row {
      button {
        display: none;
      }

      &:hover {
        button {
          display: block;
        }
      }
    }
  }
  .ReactVirtualized__Table__rowColumn {
    margin: 0;
    padding: 8px;
    margin-right: 0;
    box-sizing: border-box;
  }
`;

export const StyledLinkButton = styled(Link)`
  display: flex;
  align-items: center;
  width: fit-content;
  height: fit-content;
  padding: 5px 25px 5px 25px;
  text-align: center;
  white-space: nowrap;

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;

  cursor: pointer;
  transition: 0.2s ease;

  color: ${LIGHT_GRAY};
  background: transparent;

  border: 1px ${LIGHT_GRAY} solid;
  border-radius: 4px;
  border-width: 1px;
  border-radius: 6px;

  &:hover {
    color: ${LOW_BLUE};
    border: 1px ${LOW_BLUE} solid;
  }

  svg {
    margin-left: 8px;
  }
`;

export const Message = styled.div`
  display: flex;
  align-items: flex-end;
  color: ${NEAR_WHITE};

  svg {
    margin-right: 10px;
    align-items: flex-end;
  }
  h5 {
    margin-bottom: 0px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
  }
`;

export const Row = styled.div<ColumnsProps>`
  display: flex;
  flex-flow: row wrap;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;

  h5 {
    margin: 0;
    margin-bottom: 10px;
  }

  & > div {
    width: ${({ width }) => width ?? "100%"};

    &:not(:last-child) {
      margin-right: ${({ spacingBetween }) => (spacingBetween ? spacingBetween : "0")};
    }
  }

  margin-bottom: ${({ marginBottom }) => (marginBottom ? `${marginBottom}px` : ``)};
`;

export const ItemRow = styled.div<{ flexGrow?: number }>`
  display: flex;
  flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : 1)};
`;

export const RightItemRow = styled.div<{ flexGrow?: number }>`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : 1)};
  width: auto !important;
`;

export const Box = styled.div`
  background-color: ${GRAY};
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;

  hr {
    border-width: 0.5px;
  }
`;

export const LineHr = styled.div`
  width: 100%;
  border-bottom: 0.5px solid ${LIGHT_GRAY};
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 16px;
`;
